import React from 'react';

import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Link } from '@mui/material';

import ElementLocators from '../ElementLocators';

export const IconLink = ({
  onClick,
  icon,
  copy,
  locator,
  textClassName,
  iconClassName,
  iconContainerClassName,
  textPosition = 'right',
  target = '_self',
}: {
  onClick?: (evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  icon: IconDefinition;
  copy: string;
  locator?: ElementLocators;
  textClassName?: string;
  iconClassName?: string;
  iconContainerClassName?: string;
  textPosition?: 'right' | 'left';
  target?: '_self' | '_blank' | '_parent' | '_top';
}) => {
  return (
    <Box height="32px" display="flex" flexDirection="row" alignItems="center">
      <Link
        onClick={onClick}
        data-label={locator ?? ''}
        className={iconContainerClassName}
        target={target}
        sx={{ textDecoration: 'none', cursor: 'pointer' }}
      >
        {textPosition === 'left' && (
          <span className={textClassName}>{copy}</span>
        )}
        <Box component="span" display="inline-block" width="24px" mr={0.5}>
          <FontAwesomeIcon icon={icon} className={iconClassName} />
        </Box>
        {textPosition === 'right' && (
          <span className={textClassName}>{copy}</span>
        )}
      </Link>
    </Box>
  );
};
